var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control",domProps:{"value":_vm.value},on:{"change":_vm.onChange}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Gender")]),_c('option',{domProps:{"value":1}},[_vm._v("Male")]),_c('option',{domProps:{"value":0}},[_vm._v("Female")]),_c('option',{domProps:{"value":2}},[_vm._v("Other")])])
}
var staticRenderFns = []

export { render, staticRenderFns }